import { Link } from "react-router-dom";
import { fmtTime, fmtDayStr } from "@/lib/auditDates";
import { rowHref } from "@/components/orders/OrderRowCard";

function groupByDay(events) {
  const out = [];
  events.forEach((e) => {
    const last = out[out.length - 1];
    if (last && last.day === e.day) last.items.push(e);
    else out.push({ day: e.day, items: [e] });
  });
  return out;
}

export const ActivityView = ({ events }) => {
  if (!events.length) {
    return <div className="card-base p-10 text-center text-slate-500" data-testid="activity-empty">Sin acontecimientos en el período.</div>;
  }
  return (
    <div className="space-y-4" data-testid="activity-view">
      {groupByDay(events).map((g) => (
        <section key={g.day} className="card-base overflow-hidden" data-testid={`activity-day-${g.day}`}>
          <header className="px-4 py-2.5 bg-slate-900 text-white flex items-center justify-between">
            <span className="font-heading font-bold">{fmtDayStr(g.day)}</span>
            <span className="text-xs text-slate-300">{g.items.length} acontecimientos</span>
          </header>
          <ul className="divide-y divide-slate-100">
            {g.items.map((e) => (
              <li key={e.id}>
                <Link to={rowHref(e)} className="grid grid-cols-[64px_1fr] sm:grid-cols-[72px_160px_1fr_160px] gap-x-3 gap-y-0.5 px-4 py-2 hover:bg-blue-50/60 transition-colors text-sm" data-testid={`activity-event-${e.id}`}>
                  <span className="font-mono text-xs text-slate-500 pt-0.5">{fmtTime(e.at)}</span>
                  <span className="min-w-0">
                    <span className="font-mono text-xs text-blue-600">{e.order_number}</span>
                    {e.device_count > 1 && <span className="text-[10px] text-indigo-600 font-semibold"> · Eq. #{e.device_index}</span>}
                    <span className="block truncate text-xs text-slate-600">{e.customer_name} · {e.device_label}</span>
                  </span>
                  <span className="min-w-0 col-start-2 sm:col-start-auto">
                    <span className="font-semibold text-slate-900">{e.action}</span>
                    {e.description && <span className="block truncate text-xs text-slate-500">{e.description}</span>}
                  </span>
                  <span className="text-xs text-slate-500 col-start-2 sm:col-start-auto">
                    <span className="block truncate">Por: {e.user_name || "—"}</span>
                    {e.technician_name && <span className="block truncate">Técnico: {e.technician_name}</span>}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
};
